import React, { useState } from 'react'
import { Box, Typography } from '@mui/material'
import { StockTable } from '../component/htl-stocklist/StockTable'
import { StockFilter } from '../component/htl-stocklist/StockFilter'
import { ItemFilter } from '../component/htl-stocklist/ItemFilter'
import { Navbar } from '../component/shared/Navbar'
import { PageContainer } from '../component/styled/PageContainer'
import { Helmet } from 'react-helmet-async'

export const StockScreen = () => {
  const [department, setDepartment] = useState('')
  const [classification, setClassification] = useState('')
  const [itemId, setItemId] = useState('')
  return (
    <PageContainer>
      <Helmet titleTemplate='%s | Staff Portal' defaultTitle='Staff Portal'>
        <title>HTL Stock List</title>
      </Helmet>
      <Navbar />
      <Box p={{ xs: 3, md: 5 }}>
        <Box mb={2}>
          <Typography variant='h5'>Inventory</Typography>
        </Box>
        <StockFilter
          department={department}
          setDepartment={setDepartment}
          classification={classification}
          setClassification={setClassification}
          itemId={itemId}
          setItemId={setItemId}
        />
        {department && classification && (
          <ItemFilter
            department={department}
            classification={classification}
            setItemId={setItemId}
            itemId={itemId}
          />
        )}
        {department && classification && itemId && (
          <StockTable department={department} classification={classification} itemId={itemId} />
        )}
      </Box>
    </PageContainer>
  )
}
